import { CalendarIcon } from "@heroicons/react/24/outline";
import { FormattedMessage } from "react-intl";
import ColorLink from "../common/links/colorLink";
import { usePage } from "@inertiajs/react";
import { formatDate } from "@/utils/dates";

export default function HostPersonDetails({ user }) {
    const { auth, realm } = usePage().props;
    const created = formatDate(user.created_at, realm, {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
    return (
        <div className="mt-6 pb-6 sm:mt-12 sm:pb-12 space-y-4 border-b border-b-gray-300">
            <div className="flex space-x-4">
                <div className="flex items-center space-x-4">
                    <div>
                        {user.avatarUrl ? (
                            <img
                                className="inline-block size-16 sm:size-24 rounded-full object-cover"
                                src={user.avatarUrl}
                                alt={`Avatar for ${user.name}`}
                            />
                        ) : (
                            <span className="inline-flex size-16 sm:size-24 items-center justify-center rounded-full bg-gray-500">
                                <span className="text-xl sm:text-3xl font-medium leading-none text-white">
                                    {user.initials}
                                </span>
                            </span>
                        )}
                    </div>
                    <div>
                        <h2 className="text-lg sm:text-2xl text-gray-900">
                            <FormattedMessage id="Hosted by" />{" "}
                            <span className="font-medium">{user.name}</span>
                        </h2>
                        <div className="flex items-center text-gray-500">
                            <CalendarIcon className="size-5 hidden sm:block mr-1" />
                            <span className="font-light">
                                <FormattedMessage id="Member since" /> {created}
                            </span>
                        </div>
                        <div className="flex items-center text-sm text-gray-500">
                            <div className="mr-2">
                                <span className="font-semibold mr-1">
                                    {user.approvedOpportunityCount}
                                </span>
                                <FormattedMessage id="Opportunities" />
                            </div>
                            <div>
                                <span className="font-semibold mr-1">
                                    {user.approvedGroupCount}
                                </span>
                                <FormattedMessage id="Groups" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hidden sm:block sm:grow">
                    <div className="grid justify-items-end">
                        {auth.user && (
                            <ColorLink
                                inertia={false}
                                color="black"
                                href={`mailto:${user.contact_email}`}
                            >
                                <FormattedMessage id="Contact Organiser" />
                            </ColorLink>
                        )}
                    </div>
                </div>
            </div>
            {user.professional_biography && (
                <div className="mt-5 text-gray-900 leading-6 font-light">
                    {user.professional_biography}
                </div>
            )}
            <div className="block mt-2 sm:hidden">
                <a
                    href={`mailto:${user.contact_email}`}
                    className="font-medium underline underline-offset-4"
                >
                    <FormattedMessage id="Contact Organiser" />
                </a>
            </div>
        </div>
    );
}
